import React, { useEffect, useState } from "react";
import Button from "react-bootstrap/Button";
import TextField from "@material-ui/core/TextField";
import Modal from "react-bootstrap/Modal";
import DriveFileRenameOutlineOutlinedIcon from "@mui/icons-material/DriveFileRenameOutlineOutlined";
import { evaluatingOption } from "../JobInputData";
import { useAppDispatch, useAppSelector } from "../../useStore";
import { getallReguser } from "../../features/Registration/registrationSlice";
import { Spinners } from "../TableOptions";
import { assignNewEvalvation, reset } from "../../features/Applicant/applicantSlice";
import swal from 'sweetalert';
import ModalHeader from "../ModalHeader";

const EvalvationModal = ({ title, nametitle, name, id ,ids }: any) => {
	const dispatch = useAppDispatch();
	const { dataAll } = useAppSelector((state: { registration: any; }) => state.registration)
	const { EvalvationisError, Evalvationmessage, EvalvationisLoading, EvalvationisSuccess } = useAppSelector((state: { applicant: any; }) => state.applicant)
	const [show, setShow] = useState(false);

	const handleClose = () => setShow(false);
	const handleShow = () => setShow(true);

	
	useEffect(() => {
		if (show) {
			dispatch(getallReguser());
		}
	}, [dispatch, show]);

	const [inputs, setInputs] = useState({
		recruiterID: "",
		comment: "",
		evaluatingStatus: "",
		applicationIds: null
	});

	// console.log('inputs-name-name', inputs);

	useEffect(() => {
		if (EvalvationisError) {
			swal({
				title: "error",
				text: Evalvationmessage,
				icon: "error"
			})
		} else if (EvalvationisSuccess) {
			swal({
				title: "success",
				text: "Applicant moved to Evaluation!",
				icon: "success"
			})
			setShow(false)
			setInputs(
				{
					recruiterID: "",
					comment: "",
					evaluatingStatus: "",
					applicationIds: null
				}
			)
		}
		dispatch(reset())
	}, [EvalvationisError, EvalvationisSuccess, Evalvationmessage, dispatch])



	const handleOnChange = (input: any, value: any) => {
		setInputs((prevState: any) => ({
			...prevState,
			[input]: value,
		}));
	};

	useEffect(() => {
		setInputs((prevState: any) => {
			return ({
				...prevState,
				applicationIds: id? [id] :ids,
			});
		});
	}, [setInputs, id ,ids]);



	const handleScreening = () => {
		// @ts-ignore 
		dispatch(assignNewEvalvation(inputs));
	}

	return (
		<>
			<div onClick={handleShow} className="more-button">
				{title}
			</div>

			<Modal show={show} onHide={handleClose}>
				<ModalHeader setShow={setShow} headerTitle={"Send for Evaluation"} />
				<Modal.Body>
					<form>
					<div className="applicant-name">
              <h5>Applicant Name</h5>
              {Array.isArray(name) ? name.slice(0, 2)?.map((item) => (
                <p key={item?.id}>{`${item?.title} ${item?.firstName} ${item?.middleName} ${item?.LastName}`}</p>
              )) : null}
              {name?.length > 2 && <p>...</p>}
            </div>
						{/* <div className="applicant-name">
							<h5>Applicant Name</h5>
							<p>{nametitle + " " + name} </p>
						</div> */}
						<br />
						<div className="reviewer-name">
							<h6>Reviewer</h6>
							<select
								className="round"
								onChange={(e) => handleOnChange("recruiterID", e.target.value)}
							>
								<option>Select Reviewer</option>
								{dataAll?.data?.map((item: any) => (
									<option key={item?.id} value={item?.id} >
										{item?.firstName + " " + item?.LastName}
									</option>
								))}
							</select>


							<h6 className="mt-4">Evaluating Options</h6>
							<select
								className="round"
								value={inputs.evaluatingStatus}
								onChange={(e) => handleOnChange("evaluatingStatus", e.target.value)} >

								<option>Select Options</option>
								{evaluatingOption.map((item: any, i: any) => (
									<option key={i} value={"PENDING"}>
										{item}
									</option>
								))}
							</select>


							<div className="comment mt-4">
								<h6>Comment</h6>
								<TextField
									id="outlined-multiline-static"
									multiline
									fullWidth
									type="text"
									minRows={4}
									variant="outlined"
									style={{ margin: "10px 0" }}
									value={inputs.comment}
									onChange={(e) => handleOnChange("comment", e.target.value)}
								/>
							</div>
						</div>

					</form>
				</Modal.Body>
				<Modal.Footer>
					<Button variant="secondary" onClick={handleClose}>
						Cancel
					</Button>
					<Button id="primary" onClick={handleScreening}>
						{EvalvationisLoading ? <Spinners size={"sm"} /> : 'Send'}
					</Button>
				</Modal.Footer>
			</Modal>
		</>
	);
};
export default EvalvationModal;
